import React from 'react'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

// Shared Emotion cache so MUI v5 works with SSR. `prepend: true` ensures MUI's
// styles are injected first, allowing styled-components / user styles to override.
const emotionCache = createCache({ key: 'mui', prepend: true })

export const wrapRootElement = ({ element }) => <CacheProvider value={emotionCache}>{element}</CacheProvider>
